export default {
    welcome: '欢迎加入锐合新创工作团队',
    mineIntroduce: '我们是一家崇尚利用新兴科技提升金融行业合规与监管效率、降低合规成本的新创企业。我们欢迎优秀的合规、风险管理或技术人才以及有能力、有志向的毕业生为锐合带来全新视角，如果你希望为金融行业带来创造性、变革型的影响，我们虚位以待，只等你来。',
    title1: '招聘信息',
    title2: '投递简历',
    campusRecruitment: '校园招聘',
    socialRecruitment: '社会招聘',
    recruitNum: '招聘人数',
    recruitInfor: {
        title: '应届生招聘',
        workPlace: '工作地点',
        workPlaceValue: '北京或香港',
        scopeOfBusiness: '业务范围',
        scopeOfBusinessValue: '风险与合规',
        operatingDuty: '工作职责',
        operatingDutyList: {
            title: '您将和我们的团队一起工作，策划创造性的解决方案，习得有效的工作方式，领会商务沟通的技巧，为你的职业生涯增添各项商务及专业技能。你将会参与我们不同的金融风险管理项目，你的各项工作内容将设计',
            content1: '参与各种金融风险管理项目，包括风险数据治理和集市、流动性风险、信用风险、市场风险、利率风险、操作风险等',
            content2: '参与各种反洗钱和制裁项目，包括差距分析、政策和程序制定、风险评估、合规审查、审计、数据分析、模型/系统校准和验证、KYC审查、交易监控和筛选警报审查，反洗钱和制裁培训等',
            content3: '参与金融科技产品技术实施方案整理、业务需求设计等',
            content4: '参与行业专题研究和分析、业务文档翻译',
            content5: '上级交代的其他任务工作',
        },
        jobRequirements: '任职要求',
        jobRequirementsList: {
            content1: '金融、计算机、数学、统计学、计量经济学、法律、英语等专业，国内外名校者优先',
            content2: '具备Python、Java、SAS、Matlab、VBA的知识和实际工作经验者优先',
            content3: '流利的英语和普通话表达能力(书面和口头)，会粤语者更佳',
            content4: '强烈的责任感和高质量的工作交付能力',
            content5: '良好的人际沟通能力，自我激励能力和抗压能力',
            content6: 'FRM、CFA或相关资质优先',
        },
    },
    sendResume: '投递简历',
    personalInfor: '个人信息',
    educationalBackground: '教育背景',
    tooltipTitle: '请填写最高学历',
    attachmentUpload: '附件上传',
    name: '名字',
    inputName: '请输入你的名字',
    age: '年龄',
    inputAge: '请输入你的年龄',
    inputCorrectAge: '请输入正确的内容',
    sex: '性别',
    inputSex: '请选择你的性别',
    man: '男',
    women: '女',
    phone: '手机号',
    inputPhone: '请输入手机号',
    inputCorrectPhone: '请输入正确的手机号',
    email: '邮箱',
    inputEmail: '请输入邮箱',
    inputCorrectEmail: '请输入正确的邮箱',
    education: '学历',
    changeEducation: '请选择你的学历',
    time: '时间',
    changeStartTime: '请选择开始时间',
    changeEndTime: '请选择结束时间',
    education1: '专科',
    education2: '本科',
    education3: '硕士及以上',
    major: '所属专业',
    inputMajor: '请输入你的所属专业',
    universityOnIsGraduatedFrom: '毕业院校',
    inputCollege: '请输入你的毕业院校',
    workExperience: '工作经历',
    inputExperience: '请填写最近一家公司的经历',
    isExperience: '是否有工作经历',
    no: '否',
    yes: '是',
    companyName: '公司名称',
    inputCompanyName: '请填写你最近的公司名称',
    address: '工作地址',
    inputAddress: '请输入工作地址',
    position: '职位',
    inputPosition: '请填写你的职位',
    workStartTime: '工作开始时间',
    inputWorkStartTime: '请选择工作开始时间',
    workEndTime: '工作结束时间',
    inputWorkEndTime: '请选择工作结束时间',
    workDescribute: '工作描述',
    inputWorkDescribute: '请输入工作描述',
    workingYears: '工作年限',
    inputWorkingYears: '请输入你的工作年限',
    inputCorrectWorkingYears: '请输入正确的内容',
    positionApplied: '应聘职位',
    sendBtn: '投递',
    clickUpload: '点击上传',
    uploadSuccess: '上传成功',
    sendSuccess: '投递成功',
}